import { IComponentOptions, IController } from "angular";
import { IModalComponent } from "@gtmhub/core/routing";
import { IUser } from "../../models";
import { ActionType } from "../action-on-user/action-on-user.component";

export type ConfirmActionOnUserBindings = {
  indicators: {
    loading: boolean;
  };
  performActionOnUser(): void;
  user: IUser;
  actionType: ActionType;
};

/* eslint-disable @typescript-eslint/no-empty-interface */
export interface IConfirmActionOnUserBindings extends IModalComponent<ConfirmActionOnUserBindings> {}
export interface ConfirmActionOnUserCtrl extends IConfirmActionOnUserBindings {}

export class ConfirmActionOnUserCtrl implements IController {
  public user: IUser;
  public performActionOnUser: () => void;
  public indicators: {
    loading: boolean;
  };
  public actionType: ActionType;

  public get legend() {
    return {
      show: this.actionType === "deactivate" || this.actionType === "delete",
      textKey: {
        deactivate: "once_deactivate_cant_recover_user_data",
        delete: "once_removed_cant_recover_user_data",
      }[this.actionType],
    };
  }

  public get actionButton() {
    return {
      textKey: this.actionType,
      kind: this.actionType === "delete" ? "destructive" : "primary",
    };
  }

  public $onInit(): void {
    this.user = this.resolve.user;
    this.actionType = this.resolve.actionType;
    this.indicators = this.resolve.indicators;
    this.performActionOnUser = this.resolve.performActionOnUser;
  }
}

export const ConfirmActionOnUserComponent: IComponentOptions = {
  controller: ConfirmActionOnUserCtrl,
  templateUrl: require("./confirm-action-on-user.component.jade"),
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
};
